import React from 'react'

function ArrowUp() {
  return (
    <svg width="10" height="5" viewBox="0 0 10 5" fill="none" xmlns="http://www.w3.org/2000/svg" className="stroke-black dark:stroke-white">
      <path d="M1.5 4.25L5 0.75L8.5 4.25" stroke={"black"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default ArrowUp